import axios from "axios";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useLocation } from "react-router-dom";
import useSticky from "../../Utility/useSticky";

function Itinerary({ onSuccess, onBack, experienceId }) {
  const token = localStorage.getItem("authToken");
  const location = useLocation();
  const updateexperienceId = location.state?.experienceId;
  const isEdit = location.state?.isEdit;

  const [loading, setLoading] = useState(false);
  const [loadingSubmit, setloadingSubmit] = useState(false);
  const [packages, setPackages] = useState([]);
  const [participants, setParticipants] = useState([]);

  // Active index controls which form is visible
  const [activeIndex, setActiveIndex] = useState(0);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [packageToDelete, setPackageToDelete] = useState(null);

  const [currency, setCurrency] = useState({
    id: 6, // Default Australia
    country_name: "Australia",
    currency: "AUD",
    symbol: "$",
  });

  const [finalCurrencyId, setFinalCurrencyId] = useState(6);

  const selectedCurrency1 = JSON.parse(localStorage.getItem("selectedCurrency"));
  const selectedCurrencyFromUser = JSON.parse(localStorage.getItem("user"));
  
const selectedCurrency = selectedCurrencyFromUser.
currency_id


  // Package form state
  const [packageForms, setPackageForms] = useState([
    {
      title: "",
      selectedParticipants: ["Adult"], 
      prices: { Adult: 0 },
      isSaved: false,
    },
  ]);

  const isSticky = useSticky("sticy_fixedss", 130);

  // =========================================
  // 🔹 Fetch participants from API
  // =========================================
  useEffect(() => {
    const fetchParticipants = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_API_BASE}/host/get-participants`,
          { headers: { Authorization: `Bearer ${token}` } }
        );

        if (res.data.status && Array.isArray(res.data.data)) {
          setParticipants(res.data.data);
        } 
      } catch (err) {
        console.error(err);
      }
    };
    fetchParticipants();
  }, [token]);

 


useEffect(() => {
  const fetchCurrencyByCountry = async () => {
    const userData = JSON.parse(localStorage.getItem("user"));
    const selectedCurrencyLS = JSON.parse(localStorage.getItem("selectedCurrency"));

    const userCurrency = userData?.currency_id;
    const selectedCurrency = selectedCurrencyLS?.id;

    

    let finalCurrencyId = 6;
    if (selectedCurrency) {
      finalCurrencyId = selectedCurrency;
     
    } else if (userCurrency) {
      finalCurrencyId = userCurrency;
      
    } else {
      console.warn("⚠️ Using default currency (AUD):", finalCurrencyId);
    }

    const currencyToFetch = finalCurrencyId === 5 || finalCurrencyId === 6 ? finalCurrencyId : 6;
    

    try {
      const res = await axios.get(`${process.env.REACT_APP_API_BASE}/getCurrencyByCountry`, {
        params: { currency_id: currencyToFetch },
      });

      if (res.data.status && res.data.data) {
        setCurrency(res.data.data);
        setFinalCurrencyId(currencyToFetch); // ✅ store immediately
       
      } else {
        console.warn("⚠️ Currency API returned unexpected response:", res.data);
      }
    } catch (error) {
      console.error("❌ Error fetching currency:", error);
    }
  };

  fetchCurrencyByCountry();
}, []);




  // ✅ Load currency on mount
  useEffect(() => {
    if (selectedCurrency) {
      setCurrency({
        id: selectedCurrency.id,
        country_name: selectedCurrency.country_name,
        currency: selectedCurrency.currency,
        symbol: selectedCurrency.symbol,
      });
    }
  }, []);

  // =========================================
  // 🔹 Handle input field changes
  // =========================================
  const handlePackageChange = (index, field, value) => {
    const updated = [...packageForms];
    updated[index][field] = value;
    setPackageForms(updated);
  };

  // =========================================
  // 🔹 Toggle participant selection
  // =========================================
  const toggleParticipantSelection = (index, participantType) => {
    const updated = [...packageForms];
    const selected = updated[index].selectedParticipants;

    if (selected.includes(participantType)) {
      if (participantType === "Adult") {
      return; // Do nothing
    }
      updated[index].selectedParticipants = selected.filter(
        (t) => t !== participantType
      );
      delete updated[index].prices[participantType];
    } else {
      updated[index].selectedParticipants.push(participantType);
    }

    setPackageForms(updated);
  };

  // =========================================
  // 🔹 Handle price input for participant
  // =========================================
  const handlePriceChange = (index, participantType, value) => {
    const updated = [...packageForms];
    updated[index].prices[participantType] = value;
    setPackageForms(updated);
  };

  // =========================================
  // 🔹 Add new package (hide old form)
  // =========================================
  const addPackage = () => {
    setPackageForms([
      {
        title: "",
        selectedParticipants: ["Adult"], // default Adult
      prices: { Adult: 0 },
        isSaved: false,
      },
    ]);
    setActiveIndex(0); // show only new form
  };

  // =========================================
  // 🔹 Delete package
  // =========================================
  const deletePackage = async (index) => {
    const pkg = packages[index];

    if (pkg && pkg.id) {
      try {
        setLoading(true);
        const res = await axios.post(
          `${process.env.REACT_APP_API_BASE}/host/delete-package`,
          { 
            package_id: pkg.id,
            experience_id: updateexperienceId || experienceId
          },
          { headers: { Authorization: `Bearer ${token}` } }
        );
        if (res.data.status) {
          toast.success(res.data.message);
        } else {
          toast.error(res.data.message || "Failed to delete package");
        }
      } catch (err) {
        console.error("Error deleting package:", err);
      } finally {
        setLoading(false);
      }
    }

    setPackages((prev) => {
      const updated = [...prev];
      updated.splice(index, 1);

      if (activeIndex === index) {
        if (updated.length > 0) {
          setPackageForms([updated[0]]);
          setActiveIndex(0);
        } else {
          setPackageForms([
            {
              title: "",
              selectedParticipants: ["Adult"],
              prices: { Adult: 0 },
              isSaved: false,
            },
          ]);
          setActiveIndex(0);
        }
      } else if (activeIndex > index) {
        setActiveIndex(activeIndex - 1);
      }
      return updated;
    });
  };

  // =========================================
  // 🔹 Save / Update individual package
  // =========================================
  const handleUpdate = async (index) => {
    const pkg = packageForms[index];
    const { title, selectedParticipants, prices } = pkg;

    if (!title) {
      toast.error("Please enter Title for package!");
      return;
    }

    if (selectedParticipants.length === 0) {
      toast.error("Please select at least one participant type!");
      return;
    }

    for (let p of selectedParticipants) {
      if (!prices[p] || Number(prices[p]) <= 0) {
        toast.error(`Please enter a valid price for ${p}`);
        return;
      }
    }

     
 
    const payload = {
      ...(pkg.id && { package_id: pkg.id }),
      experience_id: updateexperienceId || experienceId,
      participents_ids: selectedParticipants
        .map((p) => {
          const found = participants.find((part) => part.title === p);
          return found ? found.id : null;
        })
        .filter(Boolean)
        .join(","),
      title,
      status: 1,
      price_pr_adult: prices["Adult"] ? Number(prices["Adult"]) : 0,
      price_pr_child: prices["Child"] ? Number(prices["Child"]) : 0,
      price_pr_infant: prices["Infant"] ? Number(prices["Infant"]) : 0,
     currency_id: Number(finalCurrencyId),

    };

    try {
      setLoading(true);
      const res = await axios.post(
        `${process.env.REACT_APP_API_BASE}/host/save-package`,
        payload,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      if (res.data.status) {
        const apiPkg = res.data.data;

        toast.success(
          pkg.id
            ? "Package updated successfully!"
            : "Package saved successfully!"
        );

        const newPkg = {
          id: apiPkg.id,
          title: apiPkg.title || "",
          maxGuests:
            apiPkg.no_of_adult ||
            apiPkg.no_of_childs ||
            apiPkg.no_of_infant ||
            "",
          selectedParticipants,
          prices,
          isSaved: true,
          currency_id: apiPkg.currency_id || currency.id,
          currency: apiPkg.currency || currency.currency,
          currency_symbol: apiPkg.currency_symbol || currency.symbol,
          country_name: apiPkg.country_name || currency.country_name,
        };

        setPackages((prev) => {
          const existsIndex = prev.findIndex((p) => p.id === apiPkg.id);
          if (existsIndex !== -1) {
            const updated = [...prev];
            updated[existsIndex] = newPkg;
            return updated;
          } else {
            return [...prev, newPkg];
          }
        });

        // ✅ Select and display the newly saved/updated package
        setPackageForms([newPkg]);
        setActiveIndex((prev) => {
          const index = packages.findIndex((p) => p.id === apiPkg.id);
          return index !== -1 ? index : packages.length; // set last added one as active
        });
      } else {
        toast.error(res.data.message || "Failed to save package");
      }
    } catch (error) {
      console.error(error);
      toast.error("Error saving package");
    } finally {
      setLoading(false);
    }
  };


 
 
 
  

  useEffect(() => {
    const fetchPackages = async () => {
      try {
        setLoading(true);
        const res = await axios.get(
          `${process.env.REACT_APP_API_BASE}/host/get-packages/${
            updateexperienceId || experienceId
          }`,
          { headers: { Authorization: `Bearer ${token}` } }
        );

        if (res.data.status && Array.isArray(res.data.data)) {
          const apiPackages = res.data.data.map((pkg) => {
            const selectedParticipants = [];
            const prices = {};

            // ✅ Convert comma-separated IDs into array of integers
            const participantIds = pkg.participents_ids
              ? pkg.participents_ids.split(",").map((id) => Number(id))
              : [];

            // ✅ Match each ID with actual participant title
            participantIds.forEach((pid) => {
              const match = participants.find((p) => p.id === pid);
              if (match) {
                selectedParticipants.push(match.title);
              }
            });

            // ✅ Map prices only for selected participant types
            selectedParticipants.forEach((title) => {
              if (title.toLowerCase().includes("adult")) {
                prices[title] = pkg.price_pr_adult || "";
              } else if (title.toLowerCase().includes("child")) {
                prices[title] = pkg.price_pr_child || "";
              } else if (title.toLowerCase().includes("infant")) {
                prices[title] = pkg.price_pr_infant || "";
              } else {
                prices[title] = pkg.price_pr_adult || ""; // fallback
              }
            });

            return {
              id: pkg.id,
              title: pkg.title || "",
              selectedParticipants,
              prices,
              isSaved: true,
              currency_id: pkg.currency_id,
              currency: pkg.currency,
              currency_symbol: pkg.currency_symbol,
              country_name: pkg.country_name,
            };
          });

          // ✅ Directly set currency symbol from API’s first package
          if (apiPackages.length > 0) {
            setCurrency({
              id: apiPackages[0].currency_id,
              country_name: apiPackages[0].country_name,
              currency: apiPackages[0].currency,
              symbol: apiPackages[0].currency_symbol,
            });
          }

          setPackages(apiPackages);
          setPackageForms([apiPackages[0]]);
          setActiveIndex(0);
        } else {
          // ✅ No package yet → fallback to localStorage
          const selectedCurrency = JSON.parse(
            localStorage.getItem("selectedCurrency")
          );
          if (selectedCurrency && selectedCurrency.symbol) {
            setCurrency({
              id: selectedCurrency.id,
              country_name: selectedCurrency.country_name,
              currency: selectedCurrency.currency,
              symbol: selectedCurrency.symbol,
            });
          }
          setPackages([]);
        }
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    // ✅ Fetch only when participants are available (to match IDs properly)
    if ((updateexperienceId || experienceId) && participants.length > 0) {
      fetchPackages();
    }
  }, [updateexperienceId, experienceId, token, participants]);

  // =========================================
  // 🔹 Final Submit (Next)
  // =========================================
  const handleSubmit = (e) => {
    e.preventDefault();
    setloadingSubmit(true);
    const newExperienceId = updateexperienceId || experienceId;

    if (!newExperienceId) {
      toast.error("Experience ID is missing!");
      setloadingSubmit(false);
      return;
    }

    // ✅ Check if at least one package is saved
    const savedPackages = packages.filter((pkg) => pkg.isSaved);
    if (savedPackages.length === 0) {
      toast.error(
        "Please add and save at least one package before proceeding!"
      );
      setloadingSubmit(false);
      return;
    }
setTimeout(() => {
    toast.success("Package details saved successfully!");
    setloadingSubmit(false);
    if (onSuccess) onSuccess(newExperienceId);
}, 1000);
  };

  return (
    <div
      className={`frm_suport_als al_bootm_spance1 mng_bothss_li  ${
        packages.length > 0 && isSticky ? "manges_bx_areea" : ""
      }`}
    >
      <div className="row">
        {/* ✅ Left Side */}
        {packages.length > 0 && (
          <div
            className={`col-lg-4 col-sm-5 ${
              packages.length > 0 ? "active-class" : ""
            } ${isSticky ? "fixedss" : ""}`}
            id="sticy_fixedss"
          >
            <div className="pakeges_ulli">
              {packages.map((pkg, index) => (
                <div className="tb_btnss" key={index} style={{ position: "relative" }}>
                  <button
                    type="button"
                    className={`al_sp_btn_blkss ${
                      activeIndex === index ? "actact" : ""
                    }`}
                    onClick={() => {
                      setPackageForms([pkg]);
                      setActiveIndex(index);
                    }}
                    style={{ paddingRight: "40px" }}
                  >
                    {pkg.title || `Package ${index + 1}`}
                  </button>
                  <button 
                    type="button" 
                    title="Delete Package"
                    style={{ position: "absolute", right: "15px", top: "50%", transform: "translateY(-50%)", background: "transparent", border: "none", color: "#ff4d4f", fontSize: "16px", cursor: "pointer", zIndex: 2 }}
                    onClick={(e) => {
                      e.stopPropagation();
                      setPackageToDelete(index);
                      setShowDeleteModal(true);
                    }}
                  >
                    <i className="fa fa-trash" aria-hidden="true"></i>
                  </button>
                </div>
              ))}
            </div>
          </div>
        )}
        {/* ✅ Right Side */}
        <div
          className={`col-lg-6 col-sm-7 ${
            packages.length > 0 ? "" : "manges_boxalgn"
          }`}
        >
          <form onSubmit={handleSubmit}>
            <div className="titlsss form_al_fildss">
              <div className="ar_bothss">
                <h5>Package Detail</h5>
                <button
                  type="button"
                  className="al_sp_btn_blk"
                  onClick={addPackage}
                >
                  <img alt="" src="/images/pls_adss.png" />
                </button>
              </div>

              {packageForms.map((pkg, index) => (
                <div key={index} className="ads_frm_areea bx_blankss mt-3">
                  <div className="form-group">
                    <label>Package Title</label>
                    <input
                      className="form-control"
                      placeholder="Add package title"
                      type="text"
                      value={pkg.title}
                      maxLength={200}
                      onChange={(e) =>
                        handlePackageChange(index, "title", e.target.value)
                      }
                    />
                  </div>

                  <div className="form-group">
                    <div className="mng_alss">
                      <label>Select Participant Type</label>
                      <div className="mng_rightstst">
                        {participants.map((p) => (
                          <button
                            key={p.id}
                            type="button"
                            className={`al_sp_btn_blk ${
                              pkg.selectedParticipants.includes(p.title)
                                ? "actact"
                                : ""
                            }`}
                            onClick={() =>
                              toggleParticipantSelection(index, p.title)
                            }
                          >
                            {p.title}
                          </button>
                        ))}
                      </div>
                    </div>
                  </div>

                  {/* <div className="form-group">
                    <label>Add your maximum number of guests</label>
                    <select
                      className="form-control"
                      value={pkg.maxGuests}
                      onChange={(e) =>
                        handlePackageChange(index, "maxGuests", e.target.value)
                      }
                    >
                      <option value="">Choose no. of maximum guests</option>
                      {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((num) => (
                        <option key={num} value={num}>
                          {num}
                        </option>
                      ))}
                    </select>

                     <input
    type="text"
    className="form-control"
    placeholder="Enter maximum no. of guests"
    value={pkg.maxGuests}
    onKeyPress={(e) => {
      if (!/[0-9]/.test(e.key)) e.preventDefault();
    }}
    onChange={(e) =>
      handlePackageChange(index, "maxGuests", e.target.value)
    }
    maxLength={3}
  />
                  </div> */}

                  {pkg.selectedParticipants.length > 0 && (
                    <div className="form-group gapmngss">
                      <label>Price for experience / per person</label>

                      {pkg.selectedParticipants.map((type) => (
                        <div
                          className="mng_alss"
                          key={type}
                          style={{ position: "relative" }}
                        >
                          <label>{type}</label>

                          <div
                            className="mng_rightstst dolarsign"
                            style={{ position: "relative" }}
                          >

                            <span className="price_currency1">
                              {pkg.currency_symbol || currency.symbol || "$"}
                            </span> 
                            <input
                              type="text"
                              className="form-control"
                              placeholder={`Enter price for ${type}`}
                              value={pkg.prices[type] || ""}
                              maxLength={5}
                              onChange={(e) =>
                                handlePriceChange(index, type, e.target.value)
                              }
                              onKeyPress={(e) => {
                                if (!/[0-9]/.test(e.key)) {
                                  e.preventDefault();
                                }
                              }}
                            />

                            {/* ✅ Use package-specific currency symbol */}
                             <span className="price_currency">
                              {pkg.currency || currency.currency || "AUD"}
                            </span>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}

                  <div className="form-group mt-1 text-center">
                    <button
                      type="button"
                      className="btn_allls over mr-0"
                      onClick={() => handleUpdate(index)}
                    >
                      {/* {pkg.isSaved ? "Updated" : "Update"} */}
                      {loading
                        ? isEdit
                          ? "Updating..."
                          : "Saving..."
                        : isEdit
                        ? "Update Package"
                        : "Add Package"}
                    </button>
                  </div>
                </div>
              ))}
            </div>

            <div className="titlsss form_al_fildss">
              <div className="form-group both">
                <button
                  type="button"
                  className="btn_allls over"
                  onClick={onBack}
                >
                  Back
                </button>
                <button type="submit" className="btn_allls" disabled={loading}>
                  {/* {loadingSubmit ? "Saving..." : "Next"} */}
                  {loadingSubmit ? (
                    <>
                      <span className="spinner"></span>
                    </>
                  ) : (
                    "Next"
                  )}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>

      {/* Delete Confirmation Modal */}
      {showDeleteModal && (
        <div className="cancel-overlay">
          <div className="cancel-modal" style={{ padding: "40px 30px", maxWidth: "450px" }}>
            <button className="close-btn" onClick={() => setShowDeleteModal(false)}>
              ×
            </button>
            <p className="cancel-text" style={{ margin: "20px 0 30px 0", fontSize: "18px", lineHeight: "1.5" }}>
              Are you sure you want to delete this package?
            </p>
            <div className="cancel-buttons">
              <button className="btn-no" onClick={() => setShowDeleteModal(false)}>
                No
              </button>
              <button className="btn-yes" onClick={() => {
                deletePackage(packageToDelete);
                setShowDeleteModal(false);
              }}>
                Yes
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Itinerary;
